import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { makeApiCall } from "src/api/apiRequests";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import moment from "moment";
import { LanguageDate } from "src/helpers/CheckLanguageDate";

interface ShowDiscountProps {
  onShowModal: boolean;
  setShowModal: (visible: boolean) => void;
  setModalVisible: (visible: boolean) => void;
  discountId: number;
}

const ShowDiscount: React.FC<ShowDiscountProps> = ({
  onShowModal,
  setShowModal,
  setModalVisible,
  discountId,
}) => {
  const { t } = useTranslation("");

  const [percentage, setPercentage] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [category, setCategory] = useState("");

  const [loading, setLoading] = useState<boolean>(true);

  const showDiscountInfo = async (): Promise<void> => {
    try {
      const response: any = await makeApiCall<ResponseType>(
        API_PATHS.showDiscount(discountId),
        "GET",
        API_HEADERS.authenticated
      );
      setLoading(false);
      setPercentage(response.discount?.percentage);
      setStartDate(response.discount?.start_date);
      setEndDate(response.discount?.end_date);
      setCategory(response.discount?.child_category?.title);
    } catch (error: any) {
      FLASH_MESSAGES.errorMsg(error.response.data.error);
      onClose();
    }
  };

  useEffect(() => {
    showDiscountInfo();
  }, []);

  const onClose = () => {
    setModalVisible(false);
    setShowModal(false);
  };

  return (
    <Modal
      isOpen={onShowModal && !loading}
      toggle={() => onClose()}
      size="md"
      centered
    >
      <ModalHeader
        className="text-dark font-size-15"
        toggle={() => onClose()}
        tag="span"
      >
        {t("show_discount_title")}
      </ModalHeader>
      <ModalBody>
        <div className="modal-note">{t("show_discount_details")}</div>
        <div className="row modal-requests">
          <div className="col-12 col-md-4 modal-sections mb-3">
            <span className="header-text">{t("show_discount_percentage")}</span>
            <span className="bold-text">
              {percentage ? percentage + "%" : "-"}
            </span>
          </div>
          <div className="col-12 col-md-4 modal-sections mb-3">
            <span className="header-text">{t("show_discount_start_date")}</span>
            <span className="bold-text">
              {startDate
                ? moment(startDate)
                    .locale(LanguageDate.moment)
                    .format("DD MMMM, yyyy")
                : "-"}
            </span>
          </div>
          <div className="col-12 col-md-4 modal-sections mb-3">
            <span className="header-text">{t("show_discount_end_date")}</span>
            <span className="bold-text"> {endDate
                ? moment(endDate)
                    .locale(LanguageDate.moment)
                    .format("DD MMMM, yyyy")
                : "-"}</span>
          </div>
        </div>
        <div className="row modal-requests">
          <div className="col-12 col-md-4 modal-sections mb-3">
            <span className="header-text">{t("show_discount_category")}</span>
            <span className="bold-text">
              {category ? category  : "-"}
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="button-white"
          type="button"
          onClick={() => onClose()}
        >
          {t("show_staff_close")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ShowDiscount;
